export default __webpack_public_path__ + "static/media/game.ac1e3cf4.svg";